import { EventBus } from "../../util/helper/EventBus";
import { NetworkError } from "./NetworkError";

export const NetworkErrorEventBus = new EventBus<NetworkError>();
